import { useQuery } from '@tanstack/react-query'

import { visitorParkingAPI } from '@/api/new-api'

interface GetVisitorParkingSessionRequest {
  ticketNumber: string
}

interface GetVisitorParkingSessionResponse {
  sessionId: number
  ticketNumber: string
  licensePlate: string
  endDate: number
  buildingName: string
  amount: number
}

export const getVisitorParkingSessionQueryKey = (data: GetVisitorParkingSessionRequest) => [
  'useGetVisitorParkingSession',
  data,
]

export const getVisitorParkingSession = async (data: GetVisitorParkingSessionRequest) => {
  const response = await visitorParkingAPI.get<GetVisitorParkingSessionResponse>(
    `/visitor-parking/session/${data.ticketNumber}`,
  )
  return response.data
}

export const useGetVisitorParkingSession = (data: GetVisitorParkingSessionRequest) => {
  return useQuery({
    enabled: !!data.ticketNumber,
    queryFn: () => getVisitorParkingSession(data),
    queryKey: getVisitorParkingSessionQueryKey(data),
  })
}
